import React from 'react'
import pickleballPlayPass from "../../../Asset/Membership/MembershipSchedule/pickleball-play-pass.svg"
import footballCheckboxWhite from "../../../Asset/Membership/MembershipSchedule/checkboxes/mobileView/football-unchecked.svg"
import footballCheckboxPurple from "../../../Asset/Membership/MembershipSchedule/checkboxes/mobileView/football-checked.svg"
import padelCheckboxWhite from "../../../Asset/Membership/MembershipSchedule/checkboxes/mobileView/padel-unchecked.svg"
import padelCheckboxPurple from "../../../Asset/Membership/MembershipSchedule/checkboxes/mobileView/padel-checked.svg"
import pickleballCheckboxWhite from "../../../Asset/Membership/MembershipSchedule/checkboxes/mobileView/pickleball-unchecked.svg"
import pickleballCheckboxPurple from "../../../Asset/Membership/MembershipSchedule/checkboxes/mobileView/pickleball-checked.svg"
import bronzeCheckboxWhite from "../../../Asset/Membership/MembershipSchedule/checkboxes/bronze-checkbox-white.svg"
import bronzeCheckboxPurple from "../../../Asset/Membership/MembershipSchedule/checkboxes/bronze-checkbox-purple.svg"
import silverCheckboxWhite from "../../../Asset/Membership/MembershipSchedule/checkboxes/silver-checkbox-white.svg"
import silverCheckboxPurple from "../../../Asset/Membership/MembershipSchedule/checkboxes/silver-checkbox-purple.svg"
import goldCheckboxWhite from "../../../Asset/Membership/MembershipSchedule/checkboxes/gold-checkbox-white.svg"
import goldCheckboxPurple from "../../../Asset/Membership/MembershipSchedule/checkboxes/gold-checkbox-purple.svg"
import pickleballBackground from "../../../Asset/Membership/MembershipSchedule/MobileBackground/pickleball-background.png"
import bootcampBackground from "../../../Asset/Membership/MembershipSchedule/MobileBackground/bootcamp-background.png"
import emptyBackground from "../../../Asset/Membership/MembershipSchedule/MobileBackground/empty-background.png"

// Function to highlight specific words in offering labels
const highlightSpecialWords = (text) => {
  const specialWords = ['PlayPass', 'Coaching', 'Bootcamp', 'Social', 'Event']
  const parts = text.split(' ')

  return parts.map((part, index) => {
    if (specialWords.includes(part)) {
      return <span key={index} style={{ color: '#512D9A' }}>{part}</span>
    }
    return part
  }).reduce((acc, curr, index) => {
    if (index === 0) return [curr]
    return [...acc, ' ', curr]
  }, [])
}

// Function to get mobile background based on offering label
const getMobileBackground = (label) => {
  if (label.includes('Pickleball') || label.includes('Padel')) {
    return pickleballBackground
  } else if (label.includes('Bootcamp')) {
    return bootcampBackground
  } else {
    return emptyBackground
  }
}

const MembershipScheduleSectionMobile = ({
  selectedSports,
  selectedTier,
  offerings,
  handleSportToggle,
  handleTierSelect,
  handleSeeOfferings,
  isFormValid,
  OFFERING_IMAGES,
  CREDIT_MAP
}) => {
  return (
    <div id="membership-schedule-mobile-container" className='bg-[#4D2A90] rounded-3xl p-6 w-full'>

      {/* I want to play section */}
      <div className='mb-6'>
        <h2 className='text-white font-ClashGrotesk text-2xl font-[520] mb-4'>
          I want to play
        </h2>

        <div id="membership-schedule-sport-selector-mobile" className='flex w-full gap-2'>
          {[
            {
              key: 'football',
              label: 'Football',
              whiteIcon: footballCheckboxWhite,
              purpleIcon: footballCheckboxPurple
            },
            {
              key: 'padel',
              label: 'Padel',
              whiteIcon: padelCheckboxWhite,
              purpleIcon: padelCheckboxPurple
            },
            {
              key: 'pickleball',
              label: 'Pickleball',
              whiteIcon: pickleballCheckboxWhite,
              purpleIcon: pickleballCheckboxPurple
            },
          ].map(sport => (
            <div
              key={sport.key}
              role="button"
              tabIndex={0}
              onClick={() => handleSportToggle(sport.key)}
              onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') handleSportToggle(sport.key); }}
              style={{
                WebkitTapHighlightColor: 'transparent',
                cursor: 'pointer',
                outline: 'none',
                userSelect: 'none'
              }}
              className="flex-1 p-0 m-0 leading-[0]"
            >
              <img
                src={selectedSports[sport.key] ? sport.purpleIcon : sport.whiteIcon}
                alt={sport.label}
                className="w-full h-[52px] object-fill pointer-events-none"
              />
            </div>
          ))}
        </div>
      </div>

      {/* with this tier membership section */}
      <div className='mb-4'>
        <h2 className='text-white font-ClashGrotesk text-xl font-[520] mb-3'>
          with this tier membership
        </h2>

        <div id="membership-schedule-tier-selector-mobile" className='flex w-full gap-2 mt-2'>
          {[
            {
              key: 'bronze',
              label: 'Bronze',
              whiteIcon: bronzeCheckboxWhite,
              purpleIcon: bronzeCheckboxPurple
            },
            {
              key: 'silver',
              label: 'Silver',
              whiteIcon: silverCheckboxWhite,
              purpleIcon: silverCheckboxPurple
            },
            {
              key: 'gold',
              label: 'Gold',
              whiteIcon: goldCheckboxWhite,
              purpleIcon: goldCheckboxPurple
            },
          ].map(tier => (
            <div
              key={tier.key}
              role="button"
              tabIndex={0}
              onClick={() => handleTierSelect(tier.key)}
              onKeyDown={(e) => { if (e.key === 'Enter' || e.key === ' ') handleTierSelect(tier.key); }}
              style={{
                WebkitTapHighlightColor: 'transparent',
                cursor: 'pointer',
                outline: 'none',
                userSelect: 'none'
              }}
              className="flex-1 p-0 m-0 leading-[0]"
            >
              <img
                src={selectedTier === tier.key ? tier.purpleIcon : tier.whiteIcon}
                alt={tier.label}
                className="w-full h-[52px] object-fill pointer-events-none"
              />
            </div>
          ))}
        </div>
      </div>

      {/* See Offerings button */}
      <button
        onClick={handleSeeOfferings}
        disabled={!isFormValid}
        className={`w-full font-manrope font-semibold text-lg py-3 rounded-xl transition-all mb-6 ${isFormValid
          ? 'bg-[var(--button-green)] text-[var(--home-about-us-ptn-button-grey)] hover:opacity-90'
          : 'bg-gray-400 text-gray-600 cursor-not-allowed'
          }`}
      >
        See Offerings
      </button>

      {/* Offerings section */}
      <div>
        {offerings.length === 0 ? (
          <div className="flex items-center justify-center py-8 text-gray-300 font-manrope text-sm">
            {Object.values(selectedSports).some(v => v) ? 'Select tier to preview offerings' : 'Choose a sport to see the offerings'}
          </div>
        ) : (
          <div id="offerings-scroll-container" className='flex flex-col gap-3 max-h-64 overflow-y-auto pr-2'>
            {offerings.map((offering, idx) => {
              const mobileBackground = getMobileBackground(offering.label)

              return (
                <div
                  key={idx}
                  className='relative w-full h-24 rounded-2xl overflow-hidden animate-fadeIn flex-shrink-0'
                  style={{ backgroundImage: `url(${mobileBackground})`, backgroundSize: 'cover', backgroundPosition: 'center' }}
                >
                  <div className='absolute inset-0 flex items-center justify-between px-6 text-white'>
                    <div className='w-[55%] flex items-center justify-start'>
                      <div className='flex flex-col font-ClashGrotesk font-[500] text-xl'>
                        <span className='font-manrope font-semibold text-[white]'>
                          {offering.label.split(" ")[0]}
                        </span>
                        <span className=' font-manrope text-[#996FEB]'>
                          {offering.label.includes('PlayPass') ? `PlayPass x ${offering.count}` : ''}
                          {offering.label.includes('Coaching') ? `Coaching x ${offering.count}` : ''}
                          {offering.label.includes('Bootcamp') ? `Bootcamp x ${offering.count}` : ''}
                          {offering.label.includes('Social') ? `Social x ${offering.count}` : ''}
                          {offering.label.includes('Event') ? `Event x ${offering.count}` : ''}
                        </span>
                      </div>
                    </div>
                    <div className='w-[40%] flex items-center justify-start'>
                      <div className='flex flex-col text-left font-[700]'>
                        <span className='font-manrope font-semibold text-lg text-[white]'>
                          {offering.count * (CREDIT_MAP[offering.label] || 5)} Credits
                        </span>
                        <span className='text-base font-manrope text-[#996FEB] '>
                          {CREDIT_MAP[offering.label] || 5} credits <br /> each
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              )
            })}
          </div>
        )}
      </div>

    </div>
  )
}

export default MembershipScheduleSectionMobile
